import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class EmailSubjectController implements angular.IComponentController {
    formController: angular.IFormController;
    subject: string; 
    
    static $inject = [];
}

export const wtEmailSubject: ComponentDefinition = {
    componentId: 'wtEmailSubject',
    controller: EmailSubjectController,
    template: require('./emailSubject.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        subject: '='
    }
};
